import React, { useState, useEffect } from 'react';
import Target from './Target';
import './Matrix.css';

const Matrix = ({ testID }) => {
    const [testData, setTestData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMatrixData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) throw new Error('Токен авторизации не найден');

                const response = await fetch(
                    `http://185.250.149.189:8000/api/v1/Results/Sociometric/Matrix?test_id=${testID}`,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': `Token ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);

                const result = await response.json();
                setTestData(result.results);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchMatrixData();
    }, [testID]);

    useEffect(() => {
        console.log(testData)
    }, [testData]);


    if (loading) return <div className="loading">Загрузка данных...</div>;
    if (error) return <div className="error">Ошибка: {error}</div>;
    if (!testData) return <div className="no-data">Нет данных для отображения</div>;

    return (
        <div className="matrix-container">
            <div className="targets-grid">
                {Object.entries(testData.matrix).map(([criterionId, criterion]) => (
                    <Target 
                        key={criterionId}
                        criterion={criterion}
                    />
                ))}
            </div>
        </div>
    );
};

export default Matrix;